import Alpine from "../alpine";
import { createTagify } from "./module_category";
import { insensitiveStringContains } from "../alpine/insensitiveStringContains";

Alpine.data("moduleCategoryFilter", (modulesAll = []) => {
  return {
    bulkEditMode: false,
    noTagsSelected: true,
    moduleIdsSelected: [],
    moduleIdsSelectedStr: "",
    tagify: null,
    modulesAll,
    modulesFiltered: [],

    init: async function () {
      // init tagify
      const input = document.querySelector('input[name="module_categories_bulk"]');
      if (input) {
        this.tagify = createTagify(input);
        this.tagify.on("change", (e) => {
          if (!e.detail.value) this.noTagsSelected = true;
          else this.noTagsSelected = false;
        });
      }

      // init filter toolbar
      const filterToolbarEl = document.querySelector("#js-modules-filters-toolbar");
      if (filterToolbarEl) {
        this.modulesFiltered = this.modulesAll;
        const { create } = await import("../framework/components/filter-toolbar");
        create("js-modules-filters", {
          storageKey: "js-modules-filters-" + window._current_academy_id,
        });
      }
    },

    // ----- BULK EDIT MODE -----
    enableBulkEditMode: function () {
      this.bulkEditMode = true;
    },
    disableBulkEditMode: function () {
      this.bulkEditMode = false;
      this.moduleIdsSelected = [];
      this.moduleIdsSelectedStr = "";
      this.tagify?.removeAllTags?.();
    },
    onModuleSelectionChange: function (moduleId) {
      const index = this.moduleIdsSelected.indexOf(moduleId);
      if (index === -1) this.moduleIdsSelected.push(moduleId);
      else this.moduleIdsSelected.splice(index, 1);
      this.moduleIdsSelectedStr = JSON.stringify(this.moduleIdsSelected);
    },
    shouldDisableBulkEditForm: function () {
      return this.noTagsSelected || !this.moduleIdsSelected.length;
    },
    shouldShowBulkDeleteButton: function () {
      return this.moduleIdsSelected.length > 0 && this.bulkEditMode;
    },

    // ----- FILTERS -----
    onFiltersChanged: function (newFilters = {}) {
      const categoriesQuery = newFilters["module_category[]"] || [];
      const searchQuery = newFilters.search.trim();
      this.modulesFiltered = this.modulesAll.reduce((filteredModules, module) => {
        const matchesCategory =
          categoriesQuery.length === 0 || module.categories.some(({ id }) => categoriesQuery.includes(id.toString()));
        const matchesSearch = !searchQuery || insensitiveStringContains(module.name, searchQuery);
        if (matchesCategory && matchesSearch) {
          filteredModules.push(module);
        }
        return filteredModules;
      }, []);
    },
    shouldShowModule: function (id) {
      return this.modulesFiltered.some((module) => module.id == id);
    },
    doFiltersUnmatch: function () {
      return this.modulesFiltered.length === 0 && this.modulesAll.length > 0;
    },
  };
});
